import React from 'react';
import { FormCheckbox } from 'components/form';
import { Box, Stack, Typography } from '@mui/material';
import { StageChecklistAttributeItem, StageChecklistAttribute } from '../../../types';

interface Props {
  isLoading: boolean;
  checklist: StageChecklistAttribute;
  onChange: (checklistItem: StageChecklistAttributeItem, nextValue: boolean) => void;
}

export const Checklist = ({ onChange, checklist, isLoading }: Props) => {
  return (
    <Box className="attribute-container">
      <Box className="attribute-container-header">
        <Box className="attribute-container-header">
          <Typography variant="subtitle2" component="span">
            Checklist
          </Typography>
        </Box>
      </Box>

      <Stack gap="0.5rem">
        {checklist.value.map(checklistItem => (
          <FormCheckbox
            disabled={isLoading}
            key={checklistItem.name}
            label={checklistItem.name}
            checked={checklistItem.value}
            required={checklistItem?.isRequired ?? false}
            onChange={(_, checked) => onChange(checklistItem, checked)}
          />
        ))}
      </Stack>
    </Box>
  );
};
